import React from "react";
import svg163 from "../../../../assets/svg/svg163.svg"; 

function WaterHeader({ accountNumber }) {
  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] ">
      <div className="flex items-center gap-[0.5rem]">
        <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-ink flex items-center justify-center">
          <img src={svg163} alt="svg163" />
        </div>
        <span className="text-ink font-[500] font-lexendS text-[0.875rem] leading-[1.5rem]">
          Water & Sanitation Payment
        </span>
      </div>
    </div>
  );
}

export default WaterHeader;
